import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import Header from '../../components/Header';
import { tokens } from '../../theme';
import NewsletterAdInsertionsTable from '../../components/newsletter-ads/NewsletterAdInsertionsTable';

const NewsletterAdInsertions: FC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      <Header
        title="KI Newsletter Ad Insertions"
        subtitle="AI-generated ad insertions across all newsletters"
      />
      <Box
        display="grid"
        gridTemplateColumns="1fr"
        gap="20px"
        sx={{
          backgroundColor: colors.primary[400],
          padding: '20px',
          borderRadius: '8px',
        }}
      >
        <NewsletterAdInsertionsTable />
      </Box>
    </Box>
  );
};

export default NewsletterAdInsertions;
